import React, { useEffect, useState } from 'react';

import { getEndpointByType } from '@broadleaf/admin-components/dist/metadata/utils/MetadataUtils';
import { request } from '@broadleaf/admin-components/dist/metadata/utils/request';
import { useTracking } from '@broadleaf/admin-components/dist/tracking';
import type { ICommonGridColumn } from '@broadleaf/admin-components/dist/types/common';

export const AuroraLookupColumn: React.FC<LookupColumnProps> = props => {
  const { row, header } = props;
  const { name } = header;

  const [value, setValue] = useState(row[name]);
  const hydrateConfig = getEndpointByType(header, 'HYDRATE');
  const tracking = useTracking(header);

  const readOptionForValue = val =>
    request(hydrateConfig, {
      tracking,
      id: val,
      value: val
    })
      .then(response => response.data)
      .then(data => data.name);

  useEffect(() => {
    // Aurora customization, equal instead of not equal
    if (row[name] === value) {
      // End Aurora customization
      readOptionForValue(row[name]).then(setValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div>{value}</div>;
};

export interface LookupColumnProps extends ICommonGridColumn {}

export default AuroraLookupColumn;
